import { has } from "lodash-es";

export default {
  setError: (state, payload) => {
    if (has(payload, "graphQLErrors[0].extensions")) {
      state.error = payload.graphQLErrors[0].extensions;
    }
  },
  setStep: (state, payload) => (state.step = payload),
  clearError: state => (state.error = [])
};
